module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/glossary#glo"
    }
  }, [_vm._v("Glossary of Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue: Facing the Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Garden of Eden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("2. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Turned Upside Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Occupation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day Turned to Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Descent into Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Razor’s Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rampe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prince’s Mine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death March")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Comfort Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cap Arcona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liberation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Land of Milk and Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Kind of Justice? A Kind of Peace?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Eden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#ph1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes on Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0